import React, { FC } from 'react';
import { Chip, styled } from '@material-ui/core';
import { theme } from '@/theme/mui-theme';

export const enum TagType {
  COMMON,
  DANGER,
  WARNING,
  SUCCESS
}

function typeToClassName(type: TagType) : 'common' | 'danger' | 'warning' | 'success' {
  switch (type) {
    case TagType.DANGER: {
      return 'danger';
    }

    case TagType.WARNING: {
      return 'warning';
    }

    case TagType.SUCCESS: {
      return 'success';
    }

    case TagType.COMMON:
    default: {
      return 'common';
    }
  }
}

export interface TagProps {
  readonly type?: TagType;
  readonly label: string;
}

const StyledChip = styled(Chip)({
  height: '20px',
  fontSize: '11px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: theme.tag.color,
  backgroundColor: theme.tag.backgroundColor,
  color: theme.tag.color,

  [`&.${typeToClassName(TagType.DANGER)}`]: {
    borderColor: '#EA7070',
    backgroundColor: '#EA7070',
    color: '#FFFFFF'
  },

  [`&.${typeToClassName(TagType.WARNING)}`]: {
    borderColor: '#FAB460',
    backgroundColor: '#FAB460',
    color: '#FFFFFF'
  },

  [`&.${typeToClassName(TagType.SUCCESS)}`]: {
    borderColor: '#5ECB6F',
    backgroundColor: '#5ECB6F',
    color: '#FFFFFF'
  }
});

const Tag : FC<TagProps> = ({ type = TagType.COMMON, label }) => {
  const formattedLabel = label.toUpperCase();
  const className = typeToClassName(type)

  return (
    <StyledChip
      className={className}
      label={formattedLabel}
    />
  );
};

export default Tag;
